import _extends from "@babel/runtime/helpers/extends";
import React, { useEffect, useRef, useState } from 'react';
import styled from 'styled-components';
import { white } from '../Colors/Colors';
import { GridContainerContext } from '../../contexts';
import { Input, InputLayout } from '../Input';
import ReactResizeDetector from 'react-resize-detector';
export default function GridContainer(_ref) {
  let {
    children: origChildren
  } = _ref;
  const [_positions, setPositions] = useState([]);
  const containerRef = useRef(null);
  let counter = 0;
  const cid = counter++;

  const updatePositions = () => {
    if (!(containerRef !== null && containerRef !== void 0 && containerRef.current) || !window) {
      return;
    }

    const parentRect = containerRef.current.getBoundingClientRect();
    const positions = [];

    for (let i = 0; i < (containerRef === null || containerRef === void 0 ? void 0 : containerRef.current.children.length); i++) {
      const childPositions = [];
      const child = containerRef.current.children[i];
      const childRect = child.getBoundingClientRect();
      const arr = ['top', 'right', 'bottom', 'left'];
      arr.forEach(position => {
        const lowerBound = +parentRect[position] - 2;
        const upperBound = +parentRect[position] + 2;

        if (childRect[position] >= lowerBound && childRect[position] <= upperBound) {
          childPositions.push(position);
        }
      });
      positions.push(childPositions.map(pos => "gc-".concat(pos)).join(' ') || 'gc-none');
    }

    if (_positions.join(';') !== positions.join(';')) {
      setPositions(positions);
    }
  };

  useEffect(() => {
    updatePositions();
  }, []);

  function getPositionClassNames(i) {
    if (_positions[i]) {
      return _positions[i];
    }

    return '';
  }

  function applyGridCellDecorator(child, i) {
    var _child, _Type, _child2;

    let Type = (_child = child) === null || _child === void 0 ? void 0 : _child.type;

    if (((_Type = Type) === null || _Type === void 0 ? void 0 : _Type.name) === 'Input') {
      child = /*#__PURE__*/React.createElement("div", null, /*#__PURE__*/React.createElement(InputContainer, child.props, /*#__PURE__*/React.createElement(StyledInput, _extends({
        as: Type
      }, child.props, {
        gridContainer: true
      }))));
      Type = child.type;
    }

    const classNames = getPositionClassNames(i);
    const edges = classNames.split(' ').map(edge => edge.replace(/^gc-/, ''));
    const props = { ...child.props,
      className: "".concat(((_child2 = child) === null || _child2 === void 0 ? void 0 : _child2.props.className) || '', " ").concat(classNames),
      bottomCell: ~classNames.indexOf('bottom'),
      rightCell: ~classNames.indexOf('right')
    };
    return /*#__PURE__*/React.createElement(GridContainerContext.Provider, {
      key: "gc-".concat(cid, "-").concat(i),
      value: {
        edges
      }
    }, /*#__PURE__*/React.createElement(GridCell, _extends({
      "data-testid": "GridCell",
      as: Type
    }, props)));
  }

  let children;

  if (Array.isArray(origChildren)) {
    children = origChildren.map((child, i) => {
      return applyGridCellDecorator(child, i);
    });
  } else {
    children = applyGridCellDecorator(origChildren, 0);
  }

  return /*#__PURE__*/React.createElement(ReactResizeDetector, {
    handleWidth: true,
    onResize: updatePositions
  }, /*#__PURE__*/React.createElement(StyledGridContainer, {
    "data-testid": "GridContainer",
    ref: containerRef
  }, children));
}
const FlexContainer = /*#__PURE__*/styled.div.withConfig({
  displayName: "GridContainer__FlexContainer",
  componentId: "sc-r3axx1-0"
})(["display:flex;flex-wrap:wrap;"]);
const GridCell = /*#__PURE__*/styled.div.withConfig({
  displayName: "GridContainer__GridCell",
  componentId: "sc-r3axx1-1"
})(["min-width:160px;width:", ";flex-grow:1;background-color:", ";:focus{position:relative;z-index:1;}&&{border-width:1px ", " ", " 1px;border-radius:0;}& > div{box-shadow:none;padding:0;margin:0;border-radius:inherit}"], props => props !== null && props !== void 0 && props.width ? "calc(".concat(props === null || props === void 0 ? void 0 : props.width, " - 1px)") : 'calc(33.3333% - 1px)', _ref2 => {
  var _theme$whiteSpace;

  let {
    theme
  } = _ref2;
  return (theme === null || theme === void 0 ? void 0 : (_theme$whiteSpace = theme.whiteSpace) === null || _theme$whiteSpace === void 0 ? void 0 : _theme$whiteSpace.base) || white;
}, props => props.rightCell ? '1px' : '0', props => props.bottomCell ? '1px' : '0');
GridCell.displayName = 'GridCell';
const StyledGridContainer = /*#__PURE__*/styled(FlexContainer).withConfig({
  displayName: "GridContainer__StyledGridContainer",
  componentId: "sc-r3axx1-2"
})(["& ~ &{margin-top:20px;}padding-top:1px;> .gc-top.gc-left{border-top-left-radius:5px;}> .gc-top.gc-right{border-top-right-radius:5px;}> .gc-bottom.gc-left{border-bottom-left-radius:5px;}> .gc-bottom.gc-right{border-bottom-right-radius:5px;}"]); //Once InputLayout is moved to tsx, try using StyledComponent<InputLayout, {}>

const InputContainer = /*#__PURE__*/styled(InputLayout).withConfig({
  displayName: "GridContainer__InputContainer",
  componentId: "sc-r3axx1-3"
})(["display:flex;border:none;border-radius:inherit;"]);
const StyledInput = /*#__PURE__*/styled(Input).withConfig({
  displayName: "GridContainer__StyledInput",
  componentId: "sc-r3axx1-4"
})(["border-radius:inherit;margin:0;box-shadow:none;padding:0;"]);